// routes:
export const ROOT_LOCATION_PATH = '/';
export const PEOPLE_LOCATION_PATH = `${ROOT_LOCATION_PATH}categories/:categoryId`;
export const SETTINGS_LOCATION_PATH = `${ROOT_LOCATION_PATH}settings`;

// actions:
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const SET_BUSY = 'SET_BUSY';
export const LOG_OUT = 'LOG_OUT';
export const LOG_OUT_FAIL = 'LOG_OUT_FAIL';

// media actions:
export const UPLOAD_MEDIA = 'UPLOAD_MEDIA';
export const DELETE_MEDIA = 'DELETE_MEDIA';

// popups:
export const SET_POP_UP = 'SET_POP_UP';
export const CONFIRMATION_POP_UP = 'CONFIRMATION_POP_UP';

// editors:
export const EDIT_MODE = 'EDIT_MODE';
export const CREATE_MODE = 'CREATE_MODE';

export const CHECK_SECURITY = {
	START: 'CHECK_SECURITY_START',
	SUCCESS: 'CHECK_SECURITY_SUCCESS',
	FAIL: 'CHECK_SECURITY_FAIL',
};

export const PHONE_AUTH = {
	START: 'PHONE_AUTH_START',
	SUCCESS: 'PHONE_AUTH_SUCCESS',
	FAIL: 'PHONE_AUTH_FAIL',
};

export const LOG_IN = {
	START: 'LOG_IN_START',
	SUCCESS: 'LOG_IN_SUCCESS',
	FAIL: 'LOG_IN_FAIL',
};

export const INIT = {
	START: '=== INIT_START ===',
	SUCCESS: '=== INIT_SUCCESS ===',
	FAIL: '=== INIT_FAIL ===',
};

export const GET_ITEMS = {
	START: 'GET_ITEMS_START',
	SUCCESS: 'GET_ITEMS_SUCCESS',
	FAIL: 'GET_ITEMS_FAIL',
};

export const UPDATE_ITEM = {
	START: 'UPDATE_ITEM_START',
	SUCCESS: 'UPDATE_ITEM_SUCCESS',
	FAIL: 'UPDATE_ITEM_FAIL',
};

export const UPDATE_ITEMS_ORDER = {
	START: 'UPDATE_ITEMS_ORDER_START',
	SUCCESS: 'UPDATE_ITEMS_ORDER_SUCCESS',
	FAIL: 'UPDATE_ITEMS_ORDER_FAIL',
};

export const DELETE_ITEM = {
	START: 'DELETE_ITEM_START',
	SUCCESS: 'DELETE_ITEM_SUCCESS',
	FAIL: 'DELETE_ITEM_FAIL',
};

export const GET_CATEGORIES = {
	START: 'GET_CATEGORIES_START',
	SUCCESS: 'GET_CATEGORIES_SUCCESS',
	FAIL: 'GET_CATEGORIES_FAIL',
};

export const UPDATE_CATEGORY = {
	START: 'UPDATE_CATEGORY_START',
	SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
	FAIL: 'UPDATE_CATEGORY_FAIL',
};

// settings actions:
export const GET_SETTINGS = {
	START: 'GET_SETTINGS_START',
	SUCCESS: 'GET_SETTINGS_SUCCESS',
	FAIL: 'GET_SETTINGS_FAIL',
};

export const UPDATE_SETTINGS = {
	START: 'UPDATE_SETTINGS_START',
	SUCCESS: 'UPDATE_SETTINGS_SUCCESS',
	FAIL: 'UPDATE_SETTINGS_FAIL',
};

// forms:
export const PHONE_AUTH_FORM_DEFAULTS = {
	phone: '',
};

export const PHONE_AUTH_CONFIRM_FORM_DEFAULTS = {
	code: '',
};

export const ITEM_TOOLTIP = {
	productName: '',
	brandName: '',
	price: '',
	link: '',
};

export const ITEM_EDITOR_FORM_DEFAULT = {
	id: '',
	categoryId: '',
	name: '',
	subtitle: '',
	content: {
		text: '',
		textRaw: '',
	},
	image: {
		remoteURL: '',
		file: { name: '', url: '' },
		selected: 'remoteURL', // 'remoteURL' or 'file'
	},
	mobileImg: {
		remoteURL: '',
		file: { name: '', url: '' },
		selected: 'remoteURL', // 'remoteURL' or 'file'
	},
	bannerImg: {
		remoteURL: '',
		file: { name: '', url: '' },
		selected: 'remoteURL', // 'remoteURL' or 'file'
	},
	mobileBannerImg: {
		remoteURL: '',
		file: { name: '', url: '' },
		selected: 'remoteURL', // 'remoteURL' or 'file'
	},
	audio: {
		remoteURL: '',
		file: { name: '', url: '' },
		selected: 'remoteURL', // 'remoteURL' or 'file'
	},
	order: -1,
};

// errors:
export const ACCESS_DENIED_ERROR = 'ACCESS_DENIED_ERROR';
export const SIGN_IN_PROVIDERS = {
	'facebook.com': 'facebook',
	'google.com': 'google',
	phone: 'sms',
};
